// src/pages/Tests/TestTypePage.jsx
import React from "react";
import TestListLayout from "./TestListLayout";
import { useParams } from "react-router-dom";

export default function TestTypePage() {
  const { type } = useParams();
  const titles = {
    practice: "Practice Tests",
    timed: "Timed Tests",
    exam: "Exam Mode Tests",
    adaptive: "Adaptive Tests",
  };
  return <TestListLayout type={type} title={titles[type] || "Tests"} />;
}
